import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@material-ui/core';

const AttributeChanges = ({ changes, tab }) => {
  return (
    <div style={{ marginLeft: tab * 8 }}>
      {Object.entries(changes).map(([key, change]) => {
        const capitalize = str =>
          str
            .toLowerCase()
            .replace(/_/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());

        const attributeLabel = capitalize(change.custom_label ?? key);
        const oldValueLabel = change.old_formatted ? change.old_formatted : change.old;
        const newValueLabel = change.new_formatted ? change.new_formatted : change.new;
        return (
          <div key={key}>
            <strong>{attributeLabel}</strong>: <i>{oldValueLabel}</i> → <i>{newValueLabel}</i>
          </div>
        );
      })}
    </div>
  );
};

AttributeChanges.propTypes = {
  changes: PropTypes.objectOf(
    PropTypes.shape({
      custom_label: PropTypes.string,
      old_formatted: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      old: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      new_formatted: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      new: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  tab: PropTypes.number
};

AttributeChanges.defaultProps = {
  tab: 0
};

const RelationalItem = ({ item }) => {
  if (typeof item === 'string') {
    return <i>{item}</i>;
  }

  return (
    <div style={{ marginLeft: 8 }}>
      {Object.keys(item).map(key => {
        return (
          <div key={key}>
            <strong>{key}</strong>:&nbsp;
            {item[key]}
          </div>
        );
      })}
    </div>
  );
};

const ChangelogItem = ({ item }) => {
  return (
    <>
      {!!item.changes && <AttributeChanges changes={item.changes} />}
      {!!item?.relational_changes &&
        !!item?.relational_changes?.length &&
        item.relational_changes.map(relationalChange => {
          return (
            <>
              {!!relationalChange.added && (
                <div key={`${item.id}-${relationalChange.name}-added`}>
                  <strong>Added {relationalChange.name}:</strong>&nbsp;
                  {relationalChange.added.map(addedItem => (
                    <RelationalItem item={addedItem} />
                  ))}
                </div>
              )}
              {!!relationalChange.removed && (
                <div key={`${item.id}-${relationalChange.name}-removed`}>
                  <strong>Removed {relationalChange.name}:</strong>&nbsp;
                  {relationalChange.removed.map(removedItem => (
                    <RelationalItem item={removedItem} />
                  ))}
                </div>
              )}
              {!!relationalChange.message && (
                <div key={`${item.id}-${relationalChange.name}-message`}>
                  <i>{relationalChange.message}</i>
                </div>
              )}
              {!!relationalChange.changes && Array.isArray(relationalChange.changes) && (
                <div>
                  <strong>{relationalChange.name} Changes:</strong>
                  {relationalChange.changes.map(change => (
                    <>
                      <AttributeChanges changes={change} tab={1} />
                      <Divider />
                    </>
                  ))}
                </div>
              )}
              {!!relationalChange.changes && !Array.isArray(relationalChange.changes) && (
                <div>
                  <strong>{relationalChange.name}</strong>
                  <AttributeChanges changes={relationalChange.changes} tab={1} />
                </div>
              )}
            </>
          );
        })}
    </>
  );
};

ChangelogItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    changes: PropTypes.objectOf(
      PropTypes.shape({
        custom_label: PropTypes.string,
        old_formatted: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        old: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        new_formatted: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        new: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    ),
    relational_changes: PropTypes.arrayOf(
      PropTypes.shape({
        added: PropTypes.arrayOf(PropTypes.string),
        removed: PropTypes.arrayOf(PropTypes.string),
        name: PropTypes.string.isRequired,
        message: PropTypes.string,
        changes: PropTypes.objectOf(
          PropTypes.shape({
            custom_label: PropTypes.string,
            old_formatted: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            old: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            new_formatted: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            new: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          })
        )
      })
    ),
    reason: PropTypes.string,
    author_name: PropTypes.string,
    logged_at: PropTypes.string.isRequired
  }).isRequired
};

export default ChangelogItem;
